// extracted by mini-css-extract-plugin
export var banner = "_ft-0";
export var closeButton = "_ft-2";
export var greenCheckmark = "_ft-3";
export var hereLink = "_ft-4";
export var titleIcon = "_ft-1";